<template>
  <div id="app">
    <Login
      v-on:login="loggedIn = $event.token !== null; isAdmin = $event.role === 'Admin'"
      v-if="!loggedIn"
    />
    <el-header v-if="loggedIn" style="background-color: #545c64" class="l-default__header">
      <el-menu
        :default-active="activeIndex"
        class="l-navigation"
        mode="horizontal"
        @select="handleSelect"
        background-color="#545c64"
        text-color="#fff"
        active-text-color="#00a1f1"
      >
        <el-menu-item index="overview">Overview</el-menu-item>
        <el-menu-item index="customer">Customer Management</el-menu-item>
        <el-menu-item index="settings">Settings</el-menu-item>
        <el-menu-item v-if="isAdmin" index="user">User</el-menu-item>
        <el-menu-item v-if="isAdmin" index="logs">Logs</el-menu-item>
        <el-menu-item index="account-settings">Account-Settings</el-menu-item>
      </el-menu>
      <el-menu
        background-color="#545c64"
        @select="handleSelect"
        class="l-user-menu"
        mode="horizontal"
        text-color="#fff"
      >
        <el-menu-item index="logout">Logout</el-menu-item>
      </el-menu>
    </el-header>

    <Customer v-if="activeIndex === 'customer' && loggedIn" />
    <Overview v-if="activeIndex === 'overview' && loggedIn" />
    <Settings v-if="activeIndex === 'settings' && loggedIn" />
    <User v-if="activeIndex === 'user' && loggedIn && isAdmin" />
    <Logs v-if="activeIndex === 'logs' && loggedIn && isAdmin" />
    <Account v-if="activeIndex === 'account-settings' && loggedIn" />
  </div>
</template>
<style>
.el-menu.l-user-menu {
  margin-left: auto;
}

.l-default__header {
  background-color: #fff;
  line-height: 60px;
  display: flex;
}
</style>
<script>
import Customer from "./components/Customer.vue";
import Overview from "./components/Overview.vue";
import Settings from "./components/Settings.vue";
import User from "./components/User.vue";
import Login from "./components/Login.vue";
import Logs from "./components/Logs.vue";
import Account from "./components/Account.vue";

import { isLoggedIn, getUserRole, Logout } from "./api.js";

export default {
  name: "app",
  components: {
    Customer,
    Overview,
    Settings,
    User,
    Login,
    Logs,
    Account
  },
  data: function() {
    return {
      activeIndex: "overview",
      token: "",
      loggedIn: false,
      isAdmin: false
    };
  },
  props: {},
  methods: {
    handleSelect(key) {
      if (key === "logout") {
        Logout();
      }
      this.activeIndex = key;
    },
    checkLogin() {
      this.loggedIn = isLoggedIn();
    },
    getRole() {
      this.isAdmin = getUserRole() === "Admin";
    }
  },
  mounted() {
    this.checkLogin();
    this.getRole();
  }
};
</script>

<style>
body {
  font-family: "Arial";
}
</style>
